import { Textarea } from "@/components/ui/textarea";
import {
  CellProps,
  isMultiLineControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";
import merge from "lodash/merge";

export const TextAreaCell = (props: CellProps) => {
  const { data, id, enabled, config, uischema, path, handleChange } = props;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);

  return (
    <Textarea
      value={data || ""}
      onChange={(ev) =>
        handleChange(path, ev.target.value === "" ? undefined : ev.target.value)
      }
      id={id}
      disabled={!enabled}
      autoFocus={appliedUiSchemaOptions.focus}
      placeholder={appliedUiSchemaOptions.placeholder}
    />
  );
};

export const textAreaCellTester: RankedTester = rankWith(3, isMultiLineControl);

export default withJsonFormsCellProps(TextAreaCell);
